// extracted by mini-css-extract-plugin
export default {"host":"PrimaryButton_host__Ty3y2"};